import React from 'react';
import { useRoutes, Routes, Route, HashRouter as Router } from 'react-router-dom';
import Home from './screens/Cadastrar/Cadastrar';
import About from './screens/Doadores/Doadores';

const App = () => {
    return(
//    <Router>
    <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/cadastrar" element={<Home />} />
        <Route path="/doadores" element={<About /> } />
  {/* let routes = useRoutes([
    { path: '/cadastrar', element: <Home /> },
    { path: '/doadores', element: <About /> },
  ]); */}
  </Routes>
//   </Router>
    )
//   return routes;
};

export default App;